import { Subject } from 'rxjs';

const subject = new Subject();

export const SnackService = {
    sendMSG: (msg: string) => subject.next(msg),
    getMSG: () => subject.asObservable()
};